/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { get, toString, isEmpty, isNil, reduce } from 'lodash';
import { unstable } from '@broadleaf/admin-components';

const { ColumnPropTypes, metadataInvariant } = unstable;

const AuroraBrowseErrorColumn = ({ header, row }) => {
  mustHaveMetadataProps(header, ['name']);
  const value = toString(get(row, header.name));
  return (
    <div className={'tw-w-3/4 tw-text-red-700'} title={value}>
      Failed to send to DMS
    </div>
  );
};

export function mustHaveMetadataProps(metadata, requiredProps = []) {
  // gather the missing properties
  const missingProps = reduce(
    requiredProps,
    (missing, prop) =>
      isNil(get(metadata, prop)) ? [...missing, prop] : missing,
    []
  );

  // if any properties were missing this will throw an error during development
  metadataInvariant(
    isEmpty(missingProps),
    missingRequiredMetadataProp(metadata, ...missingProps),
    metadata
  );
}

export function missingRequiredMetadataProp(metadata, ...propNames) {
  return `Failed to render a metadata of type, ${
    metadata.type
  }, because of missing required metadata properties: ${JSON.stringify(
    propNames
  )}`;
}

AuroraBrowseErrorColumn.propTypes = ColumnPropTypes;

AuroraBrowseErrorColumn.TYPE = 'BROWSE_ERROR_COLUMN';

export default AuroraBrowseErrorColumn;
export { AuroraBrowseErrorColumn };
